import React from "react";
import { Link2, PenLine } from "lucide-react";

import style from "./VaccineModeSwitch.module.css";

export const VACCINE_MODE = {
  HEALTHLINK: "healthlink",
  MANUAL: "manual",
};

const modeItems = [
  {
    id: VACCINE_MODE.HEALTHLINK,
    label: "Healthlink Vaccines",
    icon: Link2,
  },
  {
    id: VACCINE_MODE.MANUAL,
    label: "Manual Vaccines",
    icon: PenLine,
  },
];

/**
 * `healthlinkDisabledReason` greys the HealthLink tab out and says why, rather than taking the
 * whole switch away.
 *
 * Hiding it was worse than it looked: the tabs vanished, Manual became the only thing on screen
 * with nothing to compare it to, and a GP's first question was "why did HL disappear?" — which
 * the screen could not answer. A disabled tab beside the one that works carries both facts, that
 * HealthLink exists and that it is unavailable for now, and the reason sits under it in words
 * rather than in a tooltip nobody hovers.
 */
export const VaccineModeSwitch = ({ mode, onChange, healthlinkDisabledReason }) => {
  return (
    <div className={style.vaccineSwitchContainer}>
      <div className={style.vaccineSwitchLinks}>
        {modeItems.map((item) => {
          const Icon = item.icon;
          const isActive = mode === item.id;
          const isDisabled =
            item.id === VACCINE_MODE.HEALTHLINK && !!healthlinkDisabledReason;

          return (
            <button
              key={item.id}
              type="button"
              data-testid={`vaccine-mode-${item.id}`}
              className={`${
                isActive
                  ? style.vaccineSwitchButtonActive
                  : style.vaccineSwitchButton
              }${isDisabled ? ` ${style.vaccineSwitchButtonDisabled}` : ""}`}
              disabled={isDisabled}
              title={isDisabled ? healthlinkDisabledReason : undefined}
              onClick={() => onChange(item.id)}
            >
              <Icon size={16} className={style.vaccineSwitchIcon} />
              <span>{item.label}</span>
            </button>
          );
        })}
      </div>

      {!!healthlinkDisabledReason && (
        <p
          className={style.vaccineSwitchDisabledReason}
          data-testid="vaccine-mode-healthlink-disabled-reason"
        >
          {healthlinkDisabledReason}
        </p>
      )}
    </div>
  );
};
